import { BaseDto } from './base.dto';
import { EntityTypeDto } from './entityType.dto';
import { PrintTemplateAvailabilityDto } from './printTemplateAvailability.dto';
import { PrintTemplateSectionDto } from './printTemplateSection.dto';

export enum PrintTemplateType{
    CODE_DRIVEN = 0,
    DYNAMIC = 1
}


export class PrintTemplateDto extends BaseDto{

    name: string;

 
    type: PrintTemplateType;


   
    entityType: EntityTypeDto;


    enabled: boolean;


    printTemplateSections?: PrintTemplateSectionDto[];
    printTemplateAvailabilities?: PrintTemplateAvailabilityDto[];
}